<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span epub:type="pagebreak" id="pg_ix" title="ix"><span class="ePub-I">I have just escaped a most unpleasant death</span><span class="ePub-I"> </span><span class="ePub-I">…</span></span></p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-B">—CAPTAIN WILLIAM LANCASTER’S SAHARA DIARY</span></p>
<p class="FM-Epigraph-non-verse-fmepi-first"><span class="ePub-I">Life at its best is short anyway</span><span class="ePub-I"> </span><span class="ePub-I">…</span></p>
<p class="FM-Epigraph-Source-fmeps"><span class="ePub-B">—JESSIE KEITH-MILLER</span><span epub:type="pagebreak" id="pg_x" title="x"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4d12f763